module.exports = __webpack_public_path__ + "366a3796dbe37285d643df0d0e2972b8.svg";